import { Box, Popover, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import AddPatientIcon from "../../../../assets/SVG/addPatientIcon";
import notReception from "../../../../assets/image/notReception.png";
import ReceptionPop from "./receptionPop";
import { getPatients } from "../../../../api/area";
import TablePatient from "../../table/tablePatient";

export default function Reception({ dataArea }) {
  const refBox = useRef();
  const [openCreatePop, setOpenCreatePop] = useState();
  const [anchorEl, setAnchorEl] = useState();
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const [ageType, setAgeType] = useState();
  const [dataPatients, setDataPatients] = useState();

  const handleClose = () => {
    setAnchorEl(null);
    // setOpenPopover(false);
    // setDate();
  };

  useEffect(() => {
    if (dataArea) {
      getPatients(dataArea[0]?.areas[0]?.id)
        .then((x) => {
          setDataPatients(x);
        })
        .catch(() => {});
    }
  }, [dataArea]);

  return (
    <Box>
      <Popover
        sx={{
          "& .MuiPaper-root": {
            width: "100px",
            height: "65px",
            padding: "15px 10px",
            borderRadius: "13px",
            bgcolor: "#B3BBBC",
          },
          // "& .MuiBackdrop-root": {
          //   backgroundColor: "#00000060",
          // },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box textAlign={"center"}>
          <Typography
            onClick={(e) => {
              setAnchorEl(null);
              setOpenCreatePop(refBox.current);
              setAgeType("ADULT");
            }}
            fontWeight={"bold"}
          >
            بزرگسالان
          </Typography>
          <Typography
            onClick={(e) => {
              setAnchorEl(null);
              setOpenCreatePop(refBox.current);
              setAgeType("CHILD");
            }}
            mt="15px"
            fontWeight={"bold"}
          >
            کودکان
          </Typography>
        </Box>
      </Popover>
      <ReceptionPop
      setDataPatients={setDataPatients}
        ageType={ageType}
        dataArea={dataArea}
        anchorEl={openCreatePop}
        setAnchorEl={setOpenCreatePop}
      />
      <Box
        display={"flex"}
        sx={{ cursor: "pointer" }}
        width="fit-content"
        alignItems="center"
        mt="30px"
        gap="5px"
        ref={refBox}
        onClick={(e) => {
          // setOpenCreatePop(e.currentTarget);
          setAnchorEl(e.currentTarget);
        }}

        // onClick={() => setShowNewNote(true)}
      >
        <AddPatientIcon />
        <Typography fontWeight="bold" mt="10px" color="#4C8395">
          بیمار جدید
        </Typography>
      </Box>
      <Typography mt="20px" fontSize="23px" color="#5B5757" fontWeight="bold">
        پذیرش بیماران
      </Typography>
      {!dataPatients?.length > 0 && (
        <Box display="flex" alignItems="center" justifyContent="center">
          <img src={notReception} style={{ marginTop: "50px" }} />
        </Box>
      )}
      {dataPatients?.length > 0 && (
        <TablePatient dataArea={dataArea} rowData={dataPatients} setDataPatients={setDataPatients} />
      )}

    </Box>
  );
}
